exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-states {\n  max-height: 60vh;\n  overflow-y: auto; }\n\n.table-states thead {\n  position: sticky;\n  top: 0;\n  background-color: #ced2dd;\n  z-index: 1; }\n\ntable {\n  border: 1px solid #ced2dd;\n  border-radius: 15px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/status/status-list/status-list.component.scss
// module id = ../../../../../src/app/admin/status/status-list/status-list.component.scss
// module chunks = status.module